import {LocationService} from '../../services/location.service';
import {Component, inject, OnDestroy, OnInit} from '@angular/core';

/**
 * Abstract base component for a screen that require's the user's location.
 *
 * Will automatically to try to obtain the location on entry, and on visibility change events (when app
 * is reentered).
 */
@Component({
  template: ''
})
export class LocationAwareComponent implements OnInit, OnDestroy {

  protected locationService: LocationService;

  private visibilityChangeListener = () => {
    if (document.visibilityState === 'visible') {
      console.debug('Updating location after becoming visible');
      this.locationService.updateCurrentLocation().catch((err) => {
        console.error(`Failed to update location: ${err}`);
      });
    }
  };

  constructor() {
    this.locationService = inject(LocationService);
  }

  ngOnInit(): void {
    this.locationService.updateCurrentLocation()
      .catch((err) => {
        console.error(`Failed to update location: ${err}`);
      })
      .finally(() => {
        // start position watch in any case
        this.locationService.startWatchingPosition();

        // show nag popup
        setTimeout(() => {
          if (this.locationService.isLocationPermissionDenied()) {
            this.locationService.showLocationDeniedModal(false);
          }
        });
      });

    document.addEventListener('visibilitychange', this.visibilityChangeListener);
  }

  ngOnDestroy(): void {
    document.removeEventListener('visibilitychange', this.visibilityChangeListener);
    this.locationService.stopWatchingPosition();
  }
}
